import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {PullRequestErrorState} from '../components/PullRequestErrorState'
import {pullRequestsChangesRoute, pullRequestsChangesWithRangeRoute} from './changes-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from './layout-route'
import {FilesComponent} from './FilesFuture'

export function ChangesEntrypointFuture() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <Changes />
    </ErrorBoundary>
  )
}

export function ChangesWithRangeEntrypointFuture() {
  return (
    <ErrorBoundary critical fallback={<PullRequestErrorState text="Changes cannot be loaded" />}>
      <ChangesWithRange />
    </ErrorBoundary>
  )
}

function Changes() {
  const {
    data: {pullRequest},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {data: routeData} = useRouteQuery(pullRequestsChangesRoute, 'mainQuery')

  return <FilesComponent pullRequest={pullRequest} routeData={routeData} />
}

function ChangesWithRange() {
  const {
    data: {pullRequest},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {data: routeData} = useRouteQuery(pullRequestsChangesWithRangeRoute, 'mainQuery')

  return <FilesComponent pullRequest={pullRequest} routeData={routeData} />
}

try{ ChangesEntrypointFuture.displayName ||= 'ChangesEntrypointFuture' } catch {}
try{ ChangesWithRangeEntrypointFuture.displayName ||= 'ChangesWithRangeEntrypointFuture' } catch {}
try{ Changes.displayName ||= 'Changes' } catch {}
try{ ChangesWithRange.displayName ||= 'ChangesWithRange' } catch {}